<div class="flex kratzer-teilnehmer kratzer-card"
     [class.kratzer-lives-good]="(match.statusCd === 'OPEN' || match.statusCd === 'ACTIVE') && matchParticipant.participant.lives > 1"
     [class.kratzer-lives-warn]="((match.statusCd === 'OPEN' || match.statusCd === 'ACTIVE') && matchParticipant.participant.lives === 1) || (match.statusCd === 'FINISH' && matchParticipant.resultLoss)">
  <div class="cell-nowrap kratzer-teilnehmer-name flex align-items-center gap-1">
    {{matchParticipant.participant.displayName}}
    @if (matchParticipant.resultPointsLeft > 0) {
      <span class="text-gray-600 text-xs">({{matchParticipant.resultPointsLeft}})</span>
    }
  </div>
  <div class="kratzer-teilnehmer-leben">
    {{matchParticipant.lives ? matchParticipant.lives : matchParticipant.participant.lives}}
  </div>
  <div class="kratzer-teilnehmer-button">
    @if ((!(match.statusCd === 'FINISH') && editable) || matchParticipant.resultLoss) {
      <p-button (click)="onLossClicked()"
                [label]="((matchParticipant.resultLoss && !(match.statusCd === 'FINISH')) ? 'X' : 'LOSS_BUTTON') | translate"
                [disabled]="!(match.statusCd === 'OPEN' || match.statusCd === 'ACTIVE')"
                [styleClass]="matchParticipant.resultLoss ? 'p-button-warning' : 'p-button-secondary'"/>
    }
  </div>
</div>
